import * as React from "react";

interface AppContext {
  wrapperRef: React.RefObject<HTMLDivElement>;
}

const AppContext = React.createContext<AppContext | undefined>(undefined);

interface AppContextProviderProps {
  wrapperRef: React.RefObject<HTMLDivElement>;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
  wrapperRef,
}) => {
  return (
    <AppContext.Provider value={{ wrapperRef }}>{children}</AppContext.Provider>
  );
};

export const useAppContext = () => {
  const ctx = React.useContext(AppContext);

  if (!ctx) {
    throw Error("useAppContext used outside AppContextProvider");
  }

  return ctx;
};

export const useAppContextMethods = () => {
  const { wrapperRef } = useAppContext();

  const scrollToTop = React.useCallback(() => {
    wrapperRef.current?.scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "nearest",
    });
  }, []);

  return {
    scrollToTop,
  };
};
